import { useTranslation } from 'react-i18next';

import { GroupsRoute } from '@/features/groups/navigation/groupsRoute';
import { GroupDescriptionScreen } from '@/features/groups/screens/GroupDescriptionScreen';
import { GroupDetailScreen } from '@/features/groups/screens/GroupDetailScreen';
import { GroupEditorScreen } from '@/features/groups/screens/GroupEditorScreen';
import { GroupMembersScreen } from '@/features/groups/screens/GroupMembersScreen';
import { GroupRequestScreen } from '@/features/groups/screens/GroupRequestScreen';
import { GroupRequestsScreen } from '@/features/groups/screens/GroupRequestsScreen';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { NavigationBar } from '@/navigation/components/navbar/NavigationBar';
import { AppStack } from '@/navigation/stacks/appStack';
import { NavBarType } from '@/navigation/types/navbar';

export const useGroupsRouting = () => {
  const { t } = useTranslation(LocalizationNameSpace.GROUPS, {
    keyPrefix: 'routes'
  });

  return {
    groupsScreens: [
      <AppStack.Screen
        key={GroupsRoute.GroupDetail}
        name={GroupsRoute.GroupDetail}
        component={GroupDetailScreen}
        options={({ route }) => ({
          header: () => (
            <NavigationBar
              title={route.params.name}
              titleVariant="titleMedium"
              subTitle={t(`${GroupsRoute.GroupDetail}.members`, {
                count: route.params.memberCount ?? 0
              })}
              pictureFallback={{ text: { shortName: route.params.shortName } }}
            />
          )
        })}
      />,
      <AppStack.Screen
        key={GroupsRoute.GroupEditor}
        name={GroupsRoute.GroupEditor}
        component={GroupEditorScreen}
        options={{
          header: () => <NavigationBar type={NavBarType.MODAL_WITH_CLOSE} />,
          animation: 'fade'
        }}
      />,
      <AppStack.Screen
        key={GroupsRoute.GroupRequest}
        name={GroupsRoute.GroupRequest}
        component={GroupRequestScreen}
        options={{
          header: () => <NavigationBar type={NavBarType.MODAL_WITH_CLOSE} />,
          animation: 'fade'
        }}
      />,
      <AppStack.Screen
        key={GroupsRoute.GroupRequests}
        name={GroupsRoute.GroupRequests}
        component={GroupRequestsScreen}
        options={{
          header: () => <NavigationBar type={NavBarType.MODAL_WITH_CLOSE} />,
          animation: 'fade'
        }}
      />,
      <AppStack.Screen
        key={GroupsRoute.GroupMembers}
        name={GroupsRoute.GroupMembers}
        component={GroupMembersScreen}
        options={{
          header: () => <NavigationBar type={NavBarType.MODAL_WITH_CLOSE} />,
          animation: 'fade'
        }}
      />,
      <AppStack.Screen
        key={GroupsRoute.GroupDescription}
        name={GroupsRoute.GroupDescription}
        component={GroupDescriptionScreen}
        options={{
          header: () => <NavigationBar type={NavBarType.MODAL_WITH_CLOSE} />,
          animation: 'fade'
        }}
      />
    ]
  };
};
